import googleAnalytics from '@analytics/google-analytics';
import mixpanelPlugin from '@analytics/mixpanel';
import { Analytics } from 'analytics';
import { jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { AnalyticsProvider as AnalyticsProvider$1 } from 'use-analytics';
export { useAnalytics } from 'use-analytics';

var analytics = function(app, version, pluginsConfig) {
    var debug = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var plugins = [
        pluginsConfig.gaV4 ? googleAnalytics({
            measurementIds: [
                pluginsConfig.gaV4
            ],
            enabled: false
        }) : undefined,
        pluginsConfig.mixpanel ? mixpanelPlugin({
            token: pluginsConfig.mixpanel,
            enabled: false
        }) : undefined
    ].filter(function(p) {
        return p !== undefined;
    });
    return Analytics({
        app: app,
        version: version,
        debug: debug,
        plugins: plugins
    });
};

var AnalyticsProvider = function(param) {
    var children = param.children, instance = param.instance, enabled = param.enabled, plugins = param.plugins;
    useEffect(function() {
        enabled ? void instance.plugins.enable(plugins) : void instance.plugins.disable(plugins, function() {
            return instance.reset();
        });
    }, [
        enabled,
        instance.plugins,
        instance,
        plugins
    ]);
    return /*#__PURE__*/ jsx(AnalyticsProvider$1, {
        instance: instance,
        children: children
    });
};

export { AnalyticsProvider, analytics };
